var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'wdc-app': true, [_vm.theme]: _vm.theme },attrs:{"id":"wdc-app"}},[(_vm.excludeNavPage.includes(_vm.$route.name))?_c('router-view'):[_c('junminNav'),_c('div',{ref:"main",staticClass:"main",staticStyle:{"background-color":"#fff"}},[_c('router-view',{key:_vm.key})],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }